import {isRedirect, redirect} from '@tanstack/react-router'

import {queryClient} from '../api/query-client'
import {meQueryOptions} from './me-query'

export async function requireAuthenticatedBeforeLoad() {
    try {
        const user = await queryClient.ensureQueryData(meQueryOptions)
        if (user == null) {
            throw redirect({to: '/login'})
        }
    } catch (error) {
        if (isRedirect(error)) {
            throw error
        }
        throw error
    }
}
